import qs from 'qs';
import callApi from 'utils/callApi';
import hereApiKey from 'config/hereApiKey';

export const AUTOCOMPLETE_URL = 'https://autocomplete.search.hereapi.com/v1/autocomplete';

// Requests
export function requestFetchPlacesAutocomplete(payload) {
  return callApi(`${AUTOCOMPLETE_URL}?${qs.stringify({
    apikey: hereApiKey,
    ...payload,
  })}`, 'GET');
}



// WEBPACK FOOTER //
// ./src/redux/modules/placesAutocomplete.js